import React from 'react';
import { NumericFormat } from 'react-number-format';
import { CTextField } from './StyledComponent';
import { isEmpty } from '../utils/Helper';

function NumberTextField({
    name, label, value, prefix = "", maxValue, minValue, allowNegative = false, InputProps = {},
    allowEmpty = false, onChange, ...props
}) {
    const _value = value ?? (allowEmpty ? "" : 0);
    const isAllowed = (value) => {
        const { formattedValue, floatValue } = value
        // if (isEmpty(floatValue) && !allowEmpty) return false;
        const min = minValue ? (floatValue ?? 0) >= minValue : true;
        const max = maxValue ? (floatValue ?? 0) <= maxValue : true;
        return (min && max)
    }

    return (
        <NumericFormat
            {...props}
            label={label}
            name={name}
            value={_value}
            inputRef={props.inputRef}
            customInput={CTextField}
            error={props.error}
            helperText={props.helperText}
            prefix={prefix}
            thousandSeparator={props.thousandSeparator ?? true}
            decimalScale={props.decimalScale ?? 2}
            fixedDecimalScale={2}
            isAllowed={isAllowed}
            allowNegative={allowNegative}
            sx={{
                width: "100%",
                input: { textAlign: props.align ?? 'end' },
                "& fieldset": { border: '' },
                ...props.sx
            }}
            inputProps={{ maxLength: props.maxLength ?? 'none' }}
            InputProps={{ readOnly: props.readOnly ?? false, ...InputProps }}
            onValueChange={onChange}
            onFocus={e => [undefined, true].includes(props.focus) ? e.target.select() : null}
        />
    );
}

export default NumberTextField;